import axiosClient from './axios-client';
import type { PersonneMenage } from '../types/housekeepingMessaging';

/**
 * Les appels sans état de la messagerie interne du ménage, partagés par l'app
 * mobile et la page web de la gouvernante : chaque route n'est écrite qu'une fois.
 * Les hooks React Query (clés propres à chaque côté) vivent avec leurs écrans.
 */

export const BASE_MESSAGERIE_MENAGE = '/housekeeping/messaging';

export interface LecteurMessage extends PersonneMenage {
    read_at: string | null;
}

/** Le fil lu jusqu'au dernier message. */
export async function marquerFilLu(filId: number): Promise<void> {
    await axiosClient.post(`${BASE_MESSAGERIE_MENAGE}/threads/${filId}/read`);
}

/** « J'ai ce fil sous les yeux » : pas de push pour ce que l'écran montre déjà. */
export async function signalerFilOuvert(filId: number): Promise<void> {
    await axiosClient.post(`${BASE_MESSAGERIE_MENAGE}/threads/${filId}/viewing`);
}

/** L'écran ne montre plus le fil : les pushs reprennent tout de suite. */
export async function signalerFilFerme(filId: number): Promise<void> {
    await axiosClient.delete(`${BASE_MESSAGERIE_MENAGE}/threads/${filId}/viewing`);
}

export async function masquerMessage(messageId: number): Promise<void> {
    await axiosClient.post(`${BASE_MESSAGERIE_MENAGE}/messages/${messageId}/hide`);
}

export async function lireLecteurs(messageId: number): Promise<LecteurMessage[]> {
    return (await axiosClient.get<{ data: LecteurMessage[] }>(`${BASE_MESSAGERIE_MENAGE}/messages/${messageId}/readers`)).data.data;
}
